import React ,{useEffect} from 'react'
import { useSelector } from 'react-redux';
import { useNavigate,useLocation } from 'react-router-dom';
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const user = useSelector((state) => state?.user?.value);
  const navigate = useNavigate();
  const location = useLocation();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  useEffect(() => {
    if (!user) {
        const searchParams = new URLSearchParams(location.search);
        const queryParams = searchParams.toString();
        const pathWithParams = location.pathname + (queryParams ? `?${queryParams}` : '');
        navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", { state: { path: pathWithParams,activeLogin: true } });
    }
}, [user, navigate, location]);
    if(user){
        return(
            <Outlet/>
        )
    }else{
        return <Navigate to={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" ? "/checkout" : "/login"} state={{ activeLogin: true }} />
    }
 
}

export default ProtectedRoutes